import { AxiosRequestConfig } from "axios";
import baseApi, { version1 } from "../../Libs/Config/APIConfig";

interface CustomAxiosRequestConfig<T = unknown> extends AxiosRequestConfig<T> {}
const BaseDataConfig: CustomAxiosRequestConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const apiGetMetrics = async () => {
  return baseApi.get(`/api/${version1}/metrics/kpi`, BaseDataConfig);
};
